import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import DisposeForm from "./DisposeForm/DisposeForm";
import ExternalDisposeService from "services/ExternalDisposeService";

class ChatDispose extends Component {
  static propTypes = {
    className: PropTypes.string,
  };

  static defaultProps = {
    className: "",
  };

  constructor() {
    super();
    this.state = {
      showDisposeFlow: false,
    };
  }

  componentDidMount() {
    this.externalDisposeSubscription = ExternalDisposeService.listen().subscribe(
      this.onExternalDispose
    );
  }

  componentWillUnmount() {
    this.externalDisposeSubscription.unsubscribe();
  }

  onExternalDispose = () => {
    this.setState({
      showDisposeFlow: true,
    });
  };

  onDisposeClick = () => {
    this.setState({
      showDisposeFlow: true,
    });
  };

  onDisposeFormClose = () => {
    this.setState({
      showDisposeFlow: false,
    });
  };

  onHide = () => {
    this.onDisposeFormClose();
  };

  render() {
    const { showDisposeFlow } = this.state;
    return (
      <div className={`chat-dispose-container`}>
        <Modal
          className="chat-dispose-modal"
          show={showDisposeFlow}
          centered
          onHide={this.onHide}
        >
          <DisposeForm onFormClose={this.onDisposeFormClose} />
        </Modal>
      </div>
    );
  }
}

export default ChatDispose;
